import React, { useEffect, useState } from 'react';
import { PaymentImages, PaymentMethods } from '@/account/Interfaces';
import {
  useGetPaymentMethod,
  filterActivePaymentMethod,
} from '@/account/paymentMethodsService';
import {
  displayBraintreeMethodName,
  paymentImagesDictionary,
} from '@/account/payments/paymentsUpdateModal/PaymentsComponents/constants';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Modal, Text, Card, Button, Stack } from '@/theme/components';

export const PdfAddonCheckoutModal = ({
  open,
  onClose,
  editBilling,
  proceedToNextStep,
}: {
  open: boolean;
  onClose: () => void;
  editBilling: () => void;
  proceedToNextStep: () => void;
}) => {
  const {
    data: { pdfPrice },
    images,
  } = useAppConstantsContext();
  const paymentMethodQuery = useGetPaymentMethod();
  const [activePayment, setActivePayment] = useState<PaymentMethods>();

  useEffect(() => {
    if (!paymentMethodQuery.isLoading && !paymentMethodQuery.isError) {
      setActivePayment(filterActivePaymentMethod(paymentMethodQuery?.data));
    }
  }, [paymentMethodQuery]);

  const imgSrc =
    (activePayment &&
      images[
        (activePayment?.card_type as keyof PaymentImages) ||
          (paymentImagesDictionary[
            activePayment?.braintree_type
          ] as keyof PaymentImages)
      ]) ||
    images.genericCreditCard;

  const sixDigitMask = () => {
    if (activePayment?.card_type === 'paypal') return 'PayPal Account';
    if (activePayment?.braintree_type) {
      return displayBraintreeMethodName[activePayment?.braintree_type];
    }
    return `XX-${activePayment?.last_four}`;
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Stack gap={2.5} direction="column" alignItems="center">
        <Stack direction="column" alignItems="center" gap={1} className="1">
          <img src={images.pdfLogo} alt="PDF Logo" />
          <Text align="center" variant="h4" sx={{ margin: 0 }}>
            Enable PDFs for your reports with a one-time {pdfPrice} fee
          </Text>
        </Stack>

        <Stack margin={0} width="100%">
          <Card
            variant="outlined"
            sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
          >
            <Stack direction="row">
              <Stack direction="row" flexGrow={0.5} gap={1} alignItems="center">
                <img width={36} height={24} src={imgSrc} alt="Card Type" />
                <Text>{sixDigitMask()}</Text>
              </Stack>
              <Stack
                flexGrow={0.5}
                direction="row"
                justifyContent="right"
                alignItems="center"
              >
                <Button
                  sx={{ cursor: 'pointer', width: 'fit-content' }}
                  onClick={editBilling}
                  color="success"
                >
                  Edit Billing
                </Button>
              </Stack>
            </Stack>
            <Stack>
              <Text>{pdfPrice} for PDF acesss</Text>
              <Text sx={{ opacity: '0.6' }} variant="caption">
                One-Time Fee plus applicable sales tax
              </Text>
            </Stack>
          </Card>
        </Stack>

        <Stack direction="column" width={210} className="3">
          <Button
            onClick={proceedToNextStep}
            variant="contained"
            color="success"
          >
            Proceed to Purchase
          </Button>
          <Button onClick={onClose} color="success">
            I don't want PDF access
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
